var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icons Q2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 52",
    d: "M10 1.818A8.182 8.182 0 111.818 10 8.182 8.182 0 0110 1.818M10 0a9.954 9.954 0 107.084 2.915A10 10 0 0010 0z",
    fill: "#2C7171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 53",
    d: "M7.733 14.168l-2.51-2.933a1.2 1.2 0 01-.084-1.342.78.78 0 01.607-.416.739.739 0 01.648.316l1.924 2.287 5.272-6.263a.741.741 0 011.094.092 1.137 1.137 0 01.078 1.3l-5.857 6.96a.714.714 0 01-1.171 0z",
    fill: "#2C7171"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOk);
export default __webpack_public_path__ + "static/media/iconOk.dcd915b1.svg";
export { ForwardRef as ReactComponent };